import React from 'react';
import Dropdown from './Dropdown';
import TextInput from './TextInput';
import CalendarDatepicker from '../common/CalendarDatepicker';
import './styles/FilterCondition.scss';

interface FilterConditionProps {
  operator: string;
  value: string;
  onOperatorChange: (value: string) => void;
  onValueChange: (value: string) => void;
  type?: 'text' | 'date';
}

const FilterCondition: React.FC<FilterConditionProps> = ({
  operator,
  value,
  onOperatorChange,
  onValueChange,
  type = 'text',
}) => {
  const textOperatorOptions = [
    'is equal to',
    'is not equal to',
    'Starts with',
    'Contains',
    'Does not contain',
    'Ends with',
    'is empty',
    'is not empty',
  ];

  const dateOperatorOptions = [
    'Is equal to',
    'Is not equal to',
    'Is after or equal to',
    'Is after',
    'Is before or equal to',
    'Is before',
    'Is null',
    'Is not null',
  ];

  const operatorOptions = type === 'date' ? dateOperatorOptions : textOperatorOptions;

  return (
    <div className='filter-condition'>
      <div className='filter-condition__row'>
        <Dropdown
          options={operatorOptions}
          value={operator}
          onChange={onOperatorChange}
          className='filter-condition__operator'
        />
      </div>
      <div className='filter-condition__row'>
        {type === 'date' ? (
          <CalendarDatepicker
            selectedDate={value ? new Date(value) : null}
            setSelectedDate={(date: Date) => onValueChange(date.toISOString())}
            datepickerOnChange={(val) => {
              if (val?.startDate instanceof Date) {
                onValueChange(val.startDate.toISOString());
              }
            }}
          />
        ) : (
          <TextInput
            value={value}
            onChange={onValueChange}
            placeholder='Enter value'
            className='filter-condition__value'
          />
        )}
      </div>
    </div>
  );
};

export default FilterCondition;
